import React, { useEffect, useRef, useState } from "react";
import Data from "../../dummy";
import JobList from "./JobList";
import * as paths from "../../../constants/paths";

import {
  fetchJobs,
  searchJobsData,
  saveJobAction,
  applyJob,
  reportAnJob,
  reportAnJobPopup,
} from "../../../states/actions/fetchJobs";
import { useSelector, useDispatch } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const OpenJobs = () => {
  const [showSigninPopup, setShowSigninPopup] = useState(false);
  const navigate = useNavigate();
  const { page } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = useSelector((state) => state.fetchJobs.content);
  const isLoading = useSelector((state) => state.fetchJobs.isLoading);
  const isSearching = useSelector((state) => state.fetchJobs.isSearching);
  const isJobSaving = useSelector((state) => state.fetchJobs.isJobSaving);
  const isJobApplying = useSelector((state) => state.fetchJobs.isJobApplying);
  const isJobReporting = useSelector((state) => state.fetchJobs.isJobReporting);

  // console.log('dddddd', data);

  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading,
  );
  const showReportPopup = useSelector(
    (state) => state.fetchJobs.showReportPopup,
  );

  const jobs = useSelector((state) => state.fetchJobs.jobs);

  const totalJobs = useSelector((state) => state.fetchJobs.totalJobs);
  const occupationInsight = useSelector(
    (state) => state.fetchJobs.occupationInsight,
  );

  const plan = useSelector((state) => state.fetchSiteSettings.plan);
  const activePlan = useSelector((state) => state.fetchSiteSettings.activePlan);
  const memData = useSelector((state) => state.fetchSiteSettings.memData);

  const {
    content,
    cities,
    cats,
    types,
    degree_req,
    industries,
    meta_desc,
    site_settings,
  } = data;

  const reqParams = new URLSearchParams(location.search);
  const is_global_val = reqParams.get("is_global")
    ? reqParams.get("is_global")
    : reqParams.get("global") &&
        (reqParams.get("global") === true || reqParams.get("global") === "true")
      ? 1
      : "";
  // NOTE: the URL's filters are applied by JobList on mount (getUrlParamsObject
  // reads every filter, subTypes included). Dispatching them here as well
  // produced a second, weaker search for every page load and filter click.


  useEffect(() => {
    // Page content: filter lists, industries, cities, meta. Always needed -
    // skipping it leaves the filter sidebar empty.
    dispatch(fetchJobs({ is_global_val: is_global_val }));
  }, []);
  const isAlreadyInBasePath =
    typeof window !== "undefined" &&
    window.location.pathname.includes(`${paths.SITE_BASE_URL}`);
  const basePath = isAlreadyInBasePath ? "" : `${paths.SITE_BASE_URL}`;
  useEffect(() => {
    // console.log("is_global_val", is_global_val);
    if (parseInt(is_global_val) == 1 && memData?.mem_email) {
      // if (plan?.id && ![6, 8].includes(parseInt(plan?.id))) {
      //   // console.log("matched");
      //   navigate(basePath + "/subscription");
      // }
      const planId = parseInt(plan?.id); // Plan ID from plan
      const createdDate = activePlan?.created_date?.split(" ")[0];

      if (!planId || !activePlan) {
        navigate(basePath + "/subscription");
        return;
      }
      // Plan 6 & 8 → always allowed
      if ([6, 8].includes(planId)) {
        return;
      }

      if ([5, 7].includes(planId)) {
        if (createdDate < paths.CHK_EXPLORE_PLAN_DATE) {
          return;
        }
        navigate(basePath + "/subscription");
        return;
      }

      // if (plan?.id === undefined || !plan || plan === null) {
      //   navigate(basePath + "/subscription");
      // }
      navigate(basePath + "/subscription");
      // console.log(
      //   plan,
      //   "plan",
      //   plan?.id && ![5, 6, 7, 8].includes(parseInt(plan?.id))
      // );
    }
  }, [is_global_val, plan, memData]);

  // const searchJobs = (filters) => {
  //   dispatch(searchJobsData(filters));
  // };

  const searchJobs = (filters) => {
    // Start from whatever the visitor arrived with - utm_*, gclid, ref, _gl -
    // so campaign attribution survives the filter rewrite. Only the filter
    // keys below are replaced; everything else on the URL is kept as-is.
    const queryParams = new URLSearchParams(window.location.search);
    for (const key in filters) queryParams.delete(key);

    for (const key in filters) {
      const value = filters[key];
      // Check if the value is not null, undefined, an empty string, or an empty array
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) &&
        value !== "null" // Additional check for string "null"
      ) {
        queryParams.append(key, Array.isArray(value) ? value.join(",") : value);
      }
    }

    // Follow the page the search actually asked for, not the route param. The
    // param is whatever page the member was on when they typed, so filtering
    // from page 3 rewrote the path back to /open-jobs/3; pageNo re-seeded from
    // it and the next search asked for offset 30 of a 6-row result. The list
    // came back empty while the count, which has no LIMIT, still said 6.
    const targetPage =
      filters && filters.pageNo ? filters.pageNo : page;
    navigate(`/open-jobs/${targetPage}?${queryParams.toString()}`);
    dispatch(searchJobsData(filters));
  };

  const saveJob = (formData) => {
    dispatch(saveJobAction(formData));
  };

  const handleReportAnJob = (formData) => {
    dispatch(reportAnJob(formData));
  };

  const handleShowSigninPopup = () => {
    setShowSigninPopup(!showSigninPopup);
  };

  const handleToggleReportPopup = () => {
    dispatch(reportAnJobPopup());
  };

  useDocumentTitle(data.page_title);
  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <JobList
            data={data.content}
            jobs={jobs}
            cities={cities}
            cats={cats}
            types={types}
            degree_req={degree_req}
            industries={industries}
            searchJobs={searchJobs}
            isSearching={isSearching}
            saveJob={saveJob}
            isJobSaving={isJobSaving}
            isJobReporting={isJobReporting}
            handleReportAnJob={handleReportAnJob}
            handleShowSigninPopup={handleShowSigninPopup}
            showSigninPopup={showSigninPopup}
            showReportPopup={showReportPopup}
            handleToggleReportPopup={handleToggleReportPopup}
            totalJobs={totalJobs}
            occupationInsight={occupationInsight}
            is_global_val={is_global_val}
          />
        </>
      )}
    </>
  );
};

export default OpenJobs;
